import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { AlertsAndNotification } from '../types';
import { initialState } from './index';

const selectAlertsAndNotificationsState = (state: RootState) =>
  state.alertsAndNotifications || initialState;

export const selectAlertsAndNotifications = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.data
);

export const selectAlerts = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.alerts
);

export const selectNotifications = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.notifications
);

/** Index built from GET /notifications (banner list only) */
export const selectAlertsByIssueId = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.alertsByIssueId
);

/** Slideout: alert + issues from GET /notifications/moment/{issueId} only */
export const selectMomentAlertsByIssueId = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.momentAlertsByIssueId
);

/** Client-side computed overdue-feature alerts (separate from server-loaded alerts) */
export const selectOverdueAlerts = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.overdueAlerts || []
);

export const selectAlertByIssueId = (
  state: RootState,
  issueId: string
): AlertsAndNotification | undefined => {
  const alertsState = state.alertsAndNotifications || initialState;
  return alertsState.momentAlertsByIssueId[issueId];
};

export const selectClearedFieldRefs = (
  state: RootState,
  issueId: string
): string[] => {
  const alertsState = state.alertsAndNotifications || initialState;
  return alertsState.clearedFieldRefs[issueId] || [];
};

export const selectAlertsLoading = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.loading
);

export const selectAlertsError = createSelector(
  [selectAlertsAndNotificationsState],
  state => state.error
);

export const selectAlertCountByIssueId = (
  state: RootState,
  issueId: string
): number => {
  const alertsState = state.alertsAndNotifications || initialState;
  return alertsState.alertCountByIssueId[issueId] || 0;
};
